
export function useVariables() {
  const platformUrl: string = (window as any)._env_.REACT_APP_PLATFORM_URL;

  return {
    platformUrl,
  };
}
